import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProfilesDTO } from './dto/profiles.dto';
import { AllProfilesResponse, ProfileResponse } from '@gtpl/shared-models/hrms';
import { ProfileRequest } from './dto/profile.request';
import { ProfilesService } from './profiles.service';
import { CommonResponse } from '@gtpl/shared-models/masters';

@ApiTags('profiles')
@Controller('profiles')
export class ProfilesController {
    constructor(
        private service: ProfilesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createProfile')
    async createProfile(@Body() DTO: ProfilesDTO, isUpdate: boolean = false): Promise<ProfileResponse>{
        try{
            return await this.service.createProfile(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProfileResponse, error);
        }
    }

    @Post('/updateProfile')
    async updateProfile(@Body() DTO: ProfilesDTO, isUpdate: boolean = false): Promise<ProfileResponse>{
        try{
            return await this.service.createProfile(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProfileResponse, error);
        } 
    }

    @Post('/getAllProfiles')
    async getAllProfiles(): Promise<AllProfilesResponse>{
        try{
            return await this.service.getAllProfiles();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllProfilesResponse, error);
        }
    }

    @Post('/getAllActiveProfiles')
    async getAllActiveProfiles(): Promise<AllProfilesResponse>{
        try{
            return await this.service.getAllActiveProfiles();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllProfilesResponse, error);
        }
    }

    @Post('/activateOrDeactivateProfile')
    async activateOrDeactivate(@Body() req: ProfileRequest): Promise<ProfileResponse>{
        try{
            return await this.service.activateOrDeactivateProfile(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ProfileResponse, error)
        }
    }

    @Post("/getIDJob")
    async getIDJob( ): Promise<CommonResponse> {
        try {
            return await this.service.getIDJob()
        } catch (error) {
          
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }

    }
}
